<template>
  <div class="cont">
    <!--<div class="navTitle">当前位置：益书宝页面 > 消息中心</div>-->
    <div class="bgcBox">
      <div class="listBox">
        <div class="list" v-for="item in list" :key="item.id" @click="yl(item.id)">
          <div class="left">
            <div class="YYear">{{item.year}}</div>
            <div class="monDay">{{item.monday}}</div>
          </div>
          <div class="right">
            <div class="title">{{item.title}}</div>
            <div class="text" v-html="item.content"></div>
          </div>
        </div>
      </div>
      <div class="pageBox">
        <span @click="page.pageNum = 1">首页</span>
        <el-pagination
          background
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page.sync="page.pageNum"
          :page-size="page.pageSize"
          layout="prev, pager, next"
          :total="page.pageTotal">
        </el-pagination>
        <span @click="page.pageNum = page.pageCount">尾页</span>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: "hszBanKuai",
    data() {
      return {
        list: [],
        page: {
          pageNum: 1,
          pageSize: 20,
          pageTotal: 1,
          pageCount: 1, // 总页数gaigezhush
        }
      }
    },
    computed: {
      user() {
        return this.$store.state.user
      }
    },
    created() {
      if(!this.user){
        this.$router.push("/login")
      }
      this.$emit('setIsAct', 9),
      this.getList()
    },
    methods: {
      // 获取列表
      getList() {
        this.$api.apiAdmin.Message({
          mid: this.user.mid,
          page: this.page.pageNum,
          pagesize: this.page.pageSize
        }).then(res => {
          console.log(res)
          this.list = res.data.data
          let List = res.data.data
          List.map(item => {
            item.year = this.$tools.ZHDate(new Date(item.addtime * 1000), 8)
            item.monday = this.$tools.ZHDate(new Date(item.addtime * 1000), 4)
          })
          console.log(List)
          this.page.pageTotal = res.data.pageinfo.count
          this.page.pageCount = Math.ceil(Number(res.data.pageinfo.count) / Number(this.page.pageSize))
        }).catch(res => {
          this.$messageError(res.msg);
        })
      },
      // 点击分页
      handleSizeChange(num) {
        this.page.pageNum = num
      },
      // 选择页数
      handleCurrentChange(num) {
        this.page.pageNum = num
      },
      // 预览
      yl(id) {
        this.$router.push({
          path:'/home/xxzxDetailBanKuai',
          query: {
            page: this.page.pageNum,
            id:id
          }
        })
      },
      // 修改路径
      setPath(){
        this.$router.push({
          path:'/home/xxzxBanKuai',
          query: {
            page: this.page.pageNum
          }
        })
      },
    },
    components: {

    },
    watch: {
      'page.pageNum'() {
        this.setPath()
      },
      $route(){
        this.getList()
      }
    }
  }
</script>

<style scoped lang="scss">
  .bgc {
    background: url("../../../assets/images/xian.png") no-repeat bottom center !important;
    color: #0a2240 !important;
  }

  .cont {
    width: 1220px;
    margin: 0 auto;
    padding-bottom: 50px;
    .navTitle {
      width: 100%;
      height: 40px;
      line-height: 40px;
      color: #ffffff;
      font-size: 14px;
    }
    .bgcBox {
      display: block;
      width: 100%;
      min-height: 800px;
      background-color: #fff;
      .listBox {
        width: 100%;
        padding: 20px;
        display: flex;
        justify-content: space-between;
        flex-wrap: wrap;
        .list {
          width: 580px;
          height: 125px;
          margin-bottom: 20px;
          display: flex;
          justify-content: flex-start;
          cursor: pointer;

          .left {
            width: 124px;
            height: 125px;
            padding: 26px 20px;
            background-color: #0a2240;
            .YYear {
              width: 100%;
              font-size: 20px;
              color: #ffffff;
              border-bottom: 1px solid #fff;
              padding: 4px 0;
            }
            .monDay {
              width: 100%;
              font-size: 28px;
              color: #ffffff;
              font-weight: bold;

            }

          }
          .right {
            height: 125px;
            flex: 1;
            background-color: #f8f8f8;
            padding: 20px;
            .title {
              width: 100%;
              color: #333333;
              font-size: 18px;
              white-space: nowrap;
              overflow: hidden;
              text-overflow: ellipsis;
            }
            .text {
              width: 100%;
              font-size: 12px;
              color: #999;
              overflow: hidden;
              text-overflow: ellipsis;
              display: -webkit-box;
              -webkit-line-clamp: 2;
              -webkit-box-orient: vertical;
              margin-top: 15px;
              line-height: 18px;
            }
          }
        }
        .list:hover .right .title {
          color: #0a2240;
        }
      }
      .pageBox {
        margin-top: 80px;
        display: flex;
        justify-content: center;

        span {
          padding: 6px 10px;
          border: 1px solid #f2f2f2;
          font-size: 14px;
          color: #666666;
          cursor: pointer;
        }
      }
    }
  }

</style>
